// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_keychainapis__Buhta_keychain_v1_key from "./buhta_keychain_v1_key.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib__Bytes from "melange/bytes.js";

const Imported$pmodules = {};

const GetKeyRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1233,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetKeyResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1296,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListKeysRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1356,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListKeysResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1416,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const KeyForm = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1478,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateKeyRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1545,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateKeyResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1608,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateKeyRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1669,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateKeyResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1732,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteKeyRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1792,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteKeyResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key_service.ml",
      1850,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.keychain.v1.GetKeyRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int64_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.GetKeyRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.GetKeyRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetKeyRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.keychain.v1.GetKeyResponse";
}

function make$1(key, param) {
  return {
          key: key
        };
}

const $$let = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;

const merge_key = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "key",
            "key"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          key: Curry._2(merge_key, t1.key, t2.key)
        };
}

function spec$1(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "key",
                    "key"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.key);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(key) {
  return {
          key: key
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.GetKeyResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.key);
  };
}

function constructor$3(key) {
  return {
          key: key
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.GetKeyResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetKeyResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.keychain.v1.ListKeysRequest";
}

function make$2(grid, param) {
  return {
          grid: grid
        };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "grid",
                    "grid"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.ListKeysRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.ListKeysRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListKeysRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.keychain.v1.ListKeysResponse";
}

function make$3(keysOpt, param) {
  const keys = keysOpt !== undefined ? keysOpt : /* [] */0;
  return {
          keys: keys
        };
}

const $$let$2 = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;

const merge_keys = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "keys",
            "keys"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          keys: Curry._2(merge_keys, t1.keys, t2.keys)
        };
}

function spec$3(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "keys",
                    "keys"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.keys);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(keys) {
  return {
          keys: keys
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.ListKeysResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.keys);
  };
}

function constructor$7(keys) {
  return {
          keys: keys
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.ListKeysResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListKeysResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.keychain.v1.KeyForm";
}

function make$4(nameOpt, p12Opt, passwordOpt, param) {
  const name = nameOpt !== undefined ? nameOpt : "";
  const p12 = p12Opt !== undefined ? p12Opt : Stdlib__Bytes.of_string("");
  const password = passwordOpt !== undefined ? passwordOpt : "";
  return {
          name: name,
          p12: p12,
          password: password
        };
}

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_p12 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "p12",
            "p12"
          ],
          Ocaml_protoc_plugin__Spec.bytes,
          Stdlib__Bytes.of_string("")
        ]));

const merge_password = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "password",
            "password"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$4(t1, t2) {
  return {
          name: Curry._2(merge_name, t1.name, t2.name),
          p12: Curry._2(merge_p12, t1.p12, t2.p12),
          password: Curry._2(merge_password, t1.password, t2.password)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "name",
                    "name"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        3,
                        "p12",
                        "p12"
                      ],
                      Ocaml_protoc_plugin__Spec.bytes,
                      Stdlib__Bytes.of_string("")
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            4,
                            "password",
                            "password"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._4(serialize$4, writer, param.name, param.p12, param.password);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(name, p12, password) {
  return {
          name: name,
          p12: p12,
          password: password
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.KeyForm", spec$4(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.name, param.p12, param.password);
  };
}

function constructor$9(name, p12, password) {
  return {
          name: name,
          p12: p12,
          password: password
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.KeyForm", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, KeyForm, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.keychain.v1.CreateKeyRequest";
}

function make$5(org_idOpt, form, param) {
  const org_id = org_idOpt !== undefined ? org_idOpt : 0;
  return {
          org_id: org_id,
          form: form
        };
}

const merge_org_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "org_id",
            "orgId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_form = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "form",
            "form"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: KeyForm.name,
                make: KeyForm.make,
                from_proto: KeyForm.from_proto,
                from_proto_exn: KeyForm.from_proto_exn,
                to_proto: KeyForm.to_proto,
                to_proto$p: KeyForm.to_proto$p,
                merge: KeyForm.merge,
                to_json: KeyForm.to_json,
                from_json_exn: KeyForm.from_json_exn,
                from_json: KeyForm.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          org_id: Curry._2(merge_org_id, t1.org_id, t2.org_id),
          form: Curry._2(merge_form, t1.form, t2.form)
        };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "org_id",
                    "orgId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "form",
                        "form"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: KeyForm.name,
                            make: KeyForm.make,
                            from_proto: KeyForm.from_proto,
                            from_proto_exn: KeyForm.from_proto_exn,
                            to_proto: KeyForm.to_proto,
                            to_proto$p: KeyForm.to_proto$p,
                            merge: KeyForm.merge,
                            to_json: KeyForm.to_json,
                            from_json_exn: KeyForm.from_json_exn,
                            from_json: KeyForm.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._3(serialize$5, writer, param.org_id, param.form);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(org_id, form) {
  return {
          org_id: org_id,
          form: form
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.CreateKeyRequest", spec$5(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.org_id, param.form);
  };
}

function constructor$11(org_id, form) {
  return {
          org_id: org_id,
          form: form
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.CreateKeyRequest", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateKeyRequest, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.keychain.v1.CreateKeyResponse";
}

function make$6(key, param) {
  return {
          key: key
        };
}

const $$let$3 = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;

const merge_key$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "key",
            "key"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          key: Curry._2(merge_key$1, t1.key, t2.key)
        };
}

function spec$6(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "key",
                    "key"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.key);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(key) {
  return {
          key: key
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.CreateKeyResponse", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.key);
  };
}

function constructor$13(key) {
  return {
          key: key
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.CreateKeyResponse", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateKeyResponse, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.keychain.v1.UpdateKeyRequest";
}

function make$7(idOpt, form, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
          id: id,
          form: form
        };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const merge_form$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "form",
            "form"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: KeyForm.name,
                make: KeyForm.make,
                from_proto: KeyForm.from_proto,
                from_proto_exn: KeyForm.from_proto_exn,
                to_proto: KeyForm.to_proto,
                to_proto$p: KeyForm.to_proto$p,
                merge: KeyForm.merge,
                to_json: KeyForm.to_json,
                from_json_exn: KeyForm.from_json_exn,
                from_json: KeyForm.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          id: Curry._2(merge_id$1, t1.id, t2.id),
          form: Curry._2(merge_form$1, t1.form, t2.form)
        };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int64_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "form",
                        "form"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: KeyForm.name,
                            make: KeyForm.make,
                            from_proto: KeyForm.from_proto,
                            from_proto_exn: KeyForm.from_proto_exn,
                            to_proto: KeyForm.to_proto,
                            to_proto$p: KeyForm.to_proto$p,
                            merge: KeyForm.merge,
                            to_json: KeyForm.to_json,
                            from_json_exn: KeyForm.from_json_exn,
                            from_json: KeyForm.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.id, param.form);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(id, form) {
  return {
          id: id,
          form: form
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.UpdateKeyRequest", spec$7(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.form);
  };
}

function constructor$15(id, form) {
  return {
          id: id,
          form: form
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.UpdateKeyRequest", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateKeyRequest, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.keychain.v1.UpdateKeyResponse";
}

function make$8(key, param) {
  return {
          key: key
        };
}

const $$let$4 = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;

const merge_key$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "key",
            "key"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$8(t1, t2) {
  return {
          key: Curry._2(merge_key$2, t1.key, t2.key)
        };
}

function spec$8(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_key.Buhta.Keychain.V1.Key;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "key",
                    "key"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.key);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(key) {
  return {
          key: key
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.UpdateKeyResponse", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.key);
  };
}

function constructor$17(key) {
  return {
          key: key
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.UpdateKeyResponse", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateKeyResponse, {
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

function name$9(param) {
  return ".buhta.keychain.v1.DeleteKeyRequest";
}

function make$9(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
          id: id
        };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

function merge$9(t1, t2) {
  return {
          id: Curry._2(merge_id$2, t1.id, t2.id)
        };
}

function spec$9(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int64_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$9(undefined));
    });

function to_proto$p$9(writer, param) {
  Curry._2(serialize$9, writer, param.id);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$18(id) {
  return {
          id: id
        };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$9(undefined), constructor$18);
    });

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$9, writer);
            });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.DeleteKeyRequest", spec$9(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$19(id) {
  return {
          id: id
        };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.DeleteKeyRequest", spec$9(undefined), constructor$19);
    });

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$9, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteKeyRequest, {
      make: make$9,
      to_proto: to_proto$9,
      from_proto: from_proto$9,
      to_json: to_json$9,
      from_json: from_json$9,
      name: name$9,
      merge: merge$9,
      to_proto$p: to_proto$p$9,
      from_proto_exn: from_proto_exn$9,
      from_json_exn: from_json_exn$9
    });

function name$10(param) {
  return ".buhta.keychain.v1.DeleteKeyResponse";
}

function make$10(param) {
  
}

function merge$10(param, param$1) {
  
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
    });

function to_proto$p$10(writer, param) {
  Curry._1(serialize$10, writer);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$10, writer);
  return writer;
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_proto_exn$10, writer);
            });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.DeleteKeyResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.DeleteKeyResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_json_exn$10, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteKeyResponse, {
      make: make$10,
      to_proto: to_proto$10,
      from_proto: from_proto$10,
      to_json: to_json$10,
      from_json: from_json$10,
      name: name$10,
      merge: merge$10,
      to_proto$p: to_proto$p$10,
      from_proto_exn: from_proto_exn$10,
      from_json_exn: from_json_exn$10
    });

const getKey_0 = {
  name: GetKeyRequest.name,
  make: GetKeyRequest.make,
  from_proto: GetKeyRequest.from_proto,
  from_proto_exn: GetKeyRequest.from_proto_exn,
  to_proto: GetKeyRequest.to_proto,
  to_proto$p: GetKeyRequest.to_proto$p,
  merge: GetKeyRequest.merge,
  to_json: GetKeyRequest.to_json,
  from_json_exn: GetKeyRequest.from_json_exn,
  from_json: GetKeyRequest.from_json
};

const getKey_1 = {
  name: GetKeyResponse.name,
  make: GetKeyResponse.make,
  from_proto: GetKeyResponse.from_proto,
  from_proto_exn: GetKeyResponse.from_proto_exn,
  to_proto: GetKeyResponse.to_proto,
  to_proto$p: GetKeyResponse.to_proto$p,
  merge: GetKeyResponse.merge,
  to_json: GetKeyResponse.to_json,
  from_json_exn: GetKeyResponse.from_json_exn,
  from_json: GetKeyResponse.from_json
};

const getKey = [
  getKey_0,
  getKey_1
];

const listKeys_0 = {
  name: ListKeysRequest.name,
  make: ListKeysRequest.make,
  from_proto: ListKeysRequest.from_proto,
  from_proto_exn: ListKeysRequest.from_proto_exn,
  to_proto: ListKeysRequest.to_proto,
  to_proto$p: ListKeysRequest.to_proto$p,
  merge: ListKeysRequest.merge,
  to_json: ListKeysRequest.to_json,
  from_json_exn: ListKeysRequest.from_json_exn,
  from_json: ListKeysRequest.from_json
};

const listKeys_1 = {
  name: ListKeysResponse.name,
  make: ListKeysResponse.make,
  from_proto: ListKeysResponse.from_proto,
  from_proto_exn: ListKeysResponse.from_proto_exn,
  to_proto: ListKeysResponse.to_proto,
  to_proto$p: ListKeysResponse.to_proto$p,
  merge: ListKeysResponse.merge,
  to_json: ListKeysResponse.to_json,
  from_json_exn: ListKeysResponse.from_json_exn,
  from_json: ListKeysResponse.from_json
};

const listKeys = [
  listKeys_0,
  listKeys_1
];

const createKey_0 = {
  name: CreateKeyRequest.name,
  make: CreateKeyRequest.make,
  from_proto: CreateKeyRequest.from_proto,
  from_proto_exn: CreateKeyRequest.from_proto_exn,
  to_proto: CreateKeyRequest.to_proto,
  to_proto$p: CreateKeyRequest.to_proto$p,
  merge: CreateKeyRequest.merge,
  to_json: CreateKeyRequest.to_json,
  from_json_exn: CreateKeyRequest.from_json_exn,
  from_json: CreateKeyRequest.from_json
};

const createKey_1 = {
  name: CreateKeyResponse.name,
  make: CreateKeyResponse.make,
  from_proto: CreateKeyResponse.from_proto,
  from_proto_exn: CreateKeyResponse.from_proto_exn,
  to_proto: CreateKeyResponse.to_proto,
  to_proto$p: CreateKeyResponse.to_proto$p,
  merge: CreateKeyResponse.merge,
  to_json: CreateKeyResponse.to_json,
  from_json_exn: CreateKeyResponse.from_json_exn,
  from_json: CreateKeyResponse.from_json
};

const createKey = [
  createKey_0,
  createKey_1
];

const updateKey_0 = {
  name: UpdateKeyRequest.name,
  make: UpdateKeyRequest.make,
  from_proto: UpdateKeyRequest.from_proto,
  from_proto_exn: UpdateKeyRequest.from_proto_exn,
  to_proto: UpdateKeyRequest.to_proto,
  to_proto$p: UpdateKeyRequest.to_proto$p,
  merge: UpdateKeyRequest.merge,
  to_json: UpdateKeyRequest.to_json,
  from_json_exn: UpdateKeyRequest.from_json_exn,
  from_json: UpdateKeyRequest.from_json
};

const updateKey_1 = {
  name: UpdateKeyResponse.name,
  make: UpdateKeyResponse.make,
  from_proto: UpdateKeyResponse.from_proto,
  from_proto_exn: UpdateKeyResponse.from_proto_exn,
  to_proto: UpdateKeyResponse.to_proto,
  to_proto$p: UpdateKeyResponse.to_proto$p,
  merge: UpdateKeyResponse.merge,
  to_json: UpdateKeyResponse.to_json,
  from_json_exn: UpdateKeyResponse.from_json_exn,
  from_json: UpdateKeyResponse.from_json
};

const updateKey = [
  updateKey_0,
  updateKey_1
];

const deleteKey_0 = {
  name: DeleteKeyRequest.name,
  make: DeleteKeyRequest.make,
  from_proto: DeleteKeyRequest.from_proto,
  from_proto_exn: DeleteKeyRequest.from_proto_exn,
  to_proto: DeleteKeyRequest.to_proto,
  to_proto$p: DeleteKeyRequest.to_proto$p,
  merge: DeleteKeyRequest.merge,
  to_json: DeleteKeyRequest.to_json,
  from_json_exn: DeleteKeyRequest.from_json_exn,
  from_json: DeleteKeyRequest.from_json
};

const deleteKey_1 = {
  name: DeleteKeyResponse.name,
  make: DeleteKeyResponse.make,
  from_proto: DeleteKeyResponse.from_proto,
  from_proto_exn: DeleteKeyResponse.from_proto_exn,
  to_proto: DeleteKeyResponse.to_proto,
  to_proto$p: DeleteKeyResponse.to_proto$p,
  merge: DeleteKeyResponse.merge,
  to_json: DeleteKeyResponse.to_json,
  from_json_exn: DeleteKeyResponse.from_json_exn,
  from_json: DeleteKeyResponse.from_json
};

const deleteKey = [
  deleteKey_0,
  deleteKey_1
];

const V1_KeyService = {
  GetKey: {
    name: "/buhta.keychain.v1.KeyService/GetKey",
    package_name: "buhta.keychain.v1",
    service_name: "KeyService",
    method_name: "GetKey",
    $$Request: {
      name: GetKeyRequest.name,
      make: GetKeyRequest.make,
      from_proto: GetKeyRequest.from_proto,
      from_proto_exn: GetKeyRequest.from_proto_exn,
      to_proto: GetKeyRequest.to_proto,
      to_proto$p: GetKeyRequest.to_proto$p,
      merge: GetKeyRequest.merge,
      to_json: GetKeyRequest.to_json,
      from_json_exn: GetKeyRequest.from_json_exn,
      from_json: GetKeyRequest.from_json
    },
    $$Response: {
      name: GetKeyResponse.name,
      make: GetKeyResponse.make,
      from_proto: GetKeyResponse.from_proto,
      from_proto_exn: GetKeyResponse.from_proto_exn,
      to_proto: GetKeyResponse.to_proto,
      to_proto$p: GetKeyResponse.to_proto$p,
      merge: GetKeyResponse.merge,
      to_json: GetKeyResponse.to_json,
      from_json_exn: GetKeyResponse.from_json_exn,
      from_json: GetKeyResponse.from_json
    }
  },
  getKey: getKey,
  ListKeys: {
    name: "/buhta.keychain.v1.KeyService/ListKeys",
    package_name: "buhta.keychain.v1",
    service_name: "KeyService",
    method_name: "ListKeys",
    $$Request: {
      name: ListKeysRequest.name,
      make: ListKeysRequest.make,
      from_proto: ListKeysRequest.from_proto,
      from_proto_exn: ListKeysRequest.from_proto_exn,
      to_proto: ListKeysRequest.to_proto,
      to_proto$p: ListKeysRequest.to_proto$p,
      merge: ListKeysRequest.merge,
      to_json: ListKeysRequest.to_json,
      from_json_exn: ListKeysRequest.from_json_exn,
      from_json: ListKeysRequest.from_json
    },
    $$Response: {
      name: ListKeysResponse.name,
      make: ListKeysResponse.make,
      from_proto: ListKeysResponse.from_proto,
      from_proto_exn: ListKeysResponse.from_proto_exn,
      to_proto: ListKeysResponse.to_proto,
      to_proto$p: ListKeysResponse.to_proto$p,
      merge: ListKeysResponse.merge,
      to_json: ListKeysResponse.to_json,
      from_json_exn: ListKeysResponse.from_json_exn,
      from_json: ListKeysResponse.from_json
    }
  },
  listKeys: listKeys,
  CreateKey: {
    name: "/buhta.keychain.v1.KeyService/CreateKey",
    package_name: "buhta.keychain.v1",
    service_name: "KeyService",
    method_name: "CreateKey",
    $$Request: {
      name: CreateKeyRequest.name,
      make: CreateKeyRequest.make,
      from_proto: CreateKeyRequest.from_proto,
      from_proto_exn: CreateKeyRequest.from_proto_exn,
      to_proto: CreateKeyRequest.to_proto,
      to_proto$p: CreateKeyRequest.to_proto$p,
      merge: CreateKeyRequest.merge,
      to_json: CreateKeyRequest.to_json,
      from_json_exn: CreateKeyRequest.from_json_exn,
      from_json: CreateKeyRequest.from_json
    },
    $$Response: {
      name: CreateKeyResponse.name,
      make: CreateKeyResponse.make,
      from_proto: CreateKeyResponse.from_proto,
      from_proto_exn: CreateKeyResponse.from_proto_exn,
      to_proto: CreateKeyResponse.to_proto,
      to_proto$p: CreateKeyResponse.to_proto$p,
      merge: CreateKeyResponse.merge,
      to_json: CreateKeyResponse.to_json,
      from_json_exn: CreateKeyResponse.from_json_exn,
      from_json: CreateKeyResponse.from_json
    }
  },
  createKey: createKey,
  UpdateKey: {
    name: "/buhta.keychain.v1.KeyService/UpdateKey",
    package_name: "buhta.keychain.v1",
    service_name: "KeyService",
    method_name: "UpdateKey",
    $$Request: {
      name: UpdateKeyRequest.name,
      make: UpdateKeyRequest.make,
      from_proto: UpdateKeyRequest.from_proto,
      from_proto_exn: UpdateKeyRequest.from_proto_exn,
      to_proto: UpdateKeyRequest.to_proto,
      to_proto$p: UpdateKeyRequest.to_proto$p,
      merge: UpdateKeyRequest.merge,
      to_json: UpdateKeyRequest.to_json,
      from_json_exn: UpdateKeyRequest.from_json_exn,
      from_json: UpdateKeyRequest.from_json
    },
    $$Response: {
      name: UpdateKeyResponse.name,
      make: UpdateKeyResponse.make,
      from_proto: UpdateKeyResponse.from_proto,
      from_proto_exn: UpdateKeyResponse.from_proto_exn,
      to_proto: UpdateKeyResponse.to_proto,
      to_proto$p: UpdateKeyResponse.to_proto$p,
      merge: UpdateKeyResponse.merge,
      to_json: UpdateKeyResponse.to_json,
      from_json_exn: UpdateKeyResponse.from_json_exn,
      from_json: UpdateKeyResponse.from_json
    }
  },
  updateKey: updateKey,
  DeleteKey: {
    name: "/buhta.keychain.v1.KeyService/DeleteKey",
    package_name: "buhta.keychain.v1",
    service_name: "KeyService",
    method_name: "DeleteKey",
    $$Request: {
      name: DeleteKeyRequest.name,
      make: DeleteKeyRequest.make,
      from_proto: DeleteKeyRequest.from_proto,
      from_proto_exn: DeleteKeyRequest.from_proto_exn,
      to_proto: DeleteKeyRequest.to_proto,
      to_proto$p: DeleteKeyRequest.to_proto$p,
      merge: DeleteKeyRequest.merge,
      to_json: DeleteKeyRequest.to_json,
      from_json_exn: DeleteKeyRequest.from_json_exn,
      from_json: DeleteKeyRequest.from_json
    },
    $$Response: {
      name: DeleteKeyResponse.name,
      make: DeleteKeyResponse.make,
      from_proto: DeleteKeyResponse.from_proto,
      from_proto_exn: DeleteKeyResponse.from_proto_exn,
      to_proto: DeleteKeyResponse.to_proto,
      to_proto$p: DeleteKeyResponse.to_proto$p,
      merge: DeleteKeyResponse.merge,
      to_json: DeleteKeyResponse.to_json,
      from_json_exn: DeleteKeyResponse.from_json_exn,
      from_json: DeleteKeyResponse.from_json
    }
  },
  deleteKey: deleteKey
};

const V1 = {
  GetKeyRequest: GetKeyRequest,
  GetKeyResponse: GetKeyResponse,
  ListKeysRequest: ListKeysRequest,
  ListKeysResponse: ListKeysResponse,
  KeyForm: KeyForm,
  CreateKeyRequest: CreateKeyRequest,
  CreateKeyResponse: CreateKeyResponse,
  UpdateKeyRequest: UpdateKeyRequest,
  UpdateKeyResponse: UpdateKeyResponse,
  DeleteKeyRequest: DeleteKeyRequest,
  DeleteKeyResponse: DeleteKeyResponse,
  KeyService: V1_KeyService
};

const Keychain = {
  V1: V1
};

const Buhta = {
  Keychain: Keychain
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetKeyRequest Not a pure module */
